import { useEffect, useState } from "react";
import DoctorLayout from "@/pages/doctor/DoctorLayout";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { formatDate } from "@/lib/date";

export default function ClinicSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [address, setAddress] = useState("");
  const [start, setStart] = useState("09:00");
  const [end, setEnd] = useState("18:00");

  const load = () =>
    api.get("/doctor/clinic-settings").then(({ data }) => {
      setSettings(data);
      setAddress(data.address);
      setStart(data.clinic_timings?.start || "09:00");
      setEnd(data.clinic_timings?.end || "18:00");
    });

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    try {
      await api.put("/doctor/clinic-settings", { address, clinic_timings: { start, end } });
      toast.success("Clinic settings updated");
      load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (!settings) return <DoctorLayout><p className="text-slate-500">Loading...</p></DoctorLayout>;

  return (
    <DoctorLayout>
      <h1 className="text-2xl font-semibold text-slate-900" data-testid="clinic-settings-heading">Clinic Settings</h1>

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
          <h2 className="font-semibold text-slate-900">Subscription Detail</h2>
          <div className="mt-4 space-y-2 text-sm">
            <p><span className="text-slate-500">Plan:</span> <span className="font-medium text-slate-900">{settings.subscription_plan}</span></p>
            <p><span className="text-slate-500">Expiry Date:</span> <span className="font-medium text-slate-900">{formatDate(settings.subscription_end)}</span></p>
            <p><span className="text-slate-500">Appointments Used:</span> <span className="font-medium text-slate-900">{settings.appointments_used} / {settings.appointments_limit}</span></p>
            <p><span className="text-slate-500">Staff Limit:</span> <span className="font-medium text-slate-900">{settings.max_staff}</span></p>
            <p className="text-xs text-slate-400 mt-2">To upgrade or change your plan, please contact RootLyst support.</p>
          </div>
        </div>

        <div className="card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
          <h2 className="font-semibold text-slate-900">Clinic Profile &amp; Timings</h2>
          <div className="mt-4 space-y-4">
            <div>
              <Label>Clinic Code</Label>
              <p className="font-mono text-sm text-slate-900">{settings.clinic_code}</p>
            </div>
            <div>
              <Label>Address</Label>
              <Input data-testid="settings-address-input" value={address} onChange={(e) => setAddress(e.target.value)} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Clinic Opens</Label>
                <Input data-testid="settings-start-time" type="time" value={start} onChange={(e) => setStart(e.target.value)} />
              </div>
              <div>
                <Label>Clinic Closes</Label>
                <Input data-testid="settings-end-time" type="time" value={end} onChange={(e) => setEnd(e.target.value)} />
              </div>
            </div>
            <Button data-testid="save-clinic-settings-btn" className="bg-teal-700 hover:bg-teal-800" onClick={save}>Save Settings</Button>
          </div>
        </div>
      </div>
    </DoctorLayout>
  );
}
